const getLocalDateFromUtc = (date) => {
    return date.endsWith('Z') ? new Date(date) : new Date(date + 'z');
}

export {
    getLocalDateFromUtc
}